import { Auth } from '@polybase/auth'

const auth = new Auth()

export default auth